"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexBigInt = void 0;
const protocol_core_1 = require("@moojo/protocol-core");
exports.HexBigInt = protocol_core_1.HexString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGV4LWJpZy1pbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaGV4LWJpZy1pbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsd0RBQWdEO0FBRW5DLFFBQUEsU0FBUyxHQUFHLHlCQUFTLENBQUEifQ==